import { autoinject } from 'aurelia-dependency-injection';
import { NavigationInstruction, Next, PipelineStep, RedirectToRoute } from 'aurelia-router';
import { CustomerSettings } from '../classes/customer-settings';
import { RoleEnum } from '../classes/role-enum';
import { IRouteConfig } from '../interfaces/i-route-config';
import { OpaGetUserResultUser } from '@dynamik/common/clients/policy-clients';
import { UserContext } from './user-context';

@autoinject()
export class CheckRouteAccessStep implements PipelineStep {
  constructor(private userContext: UserContext, private customerSettings: CustomerSettings) { }

  async run(navigationInstruction: NavigationInstruction, next: Next): Promise<unknown> {
    const user = await this.userContext.get();
    if (navigationInstruction.getAllInstructions().some(i => !isRouteAllowed(i.config, user, this.customerSettings))) {
      return next.cancel(new RedirectToRoute('forbidden'));
    }
    return next();
  }
}

export function isRouteAllowed(config: IRouteConfig, user: OpaGetUserResultUser, customerSettings: CustomerSettings): boolean {
  if (!config.settings?.rolesWithAccess || user.userRoles[RoleEnum.Admin]) {
    return true;
  }
  // return config.settings.rolesWithAccess.some(x => user.customerUserRoles[customerSettings.selectedCustomer?.companyId]?.roles[x]);
  return config.settings.rolesWithAccess.some(x => user.customerUserRoles?.[customerSettings.selectedCustomer?.companyId]?.roles?.[x]);
}
